import { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass, Home, LogIn } from "lucide-react";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const passedUser = location.state?.user;
  const [isAuthenticated, setIsAuthenticated] = useState(passedUser ? true : null);

  useEffect(() => {
    if (passedUser) return;

    // Skip if hash has session_id (AuthCallback will handle)
    if (window.location.hash?.includes('session_id=')) {
      return;
    }

    const checkAuth = async () => {
      try {
        const res = await api.get("/auth/me");
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, [passedUser]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-obsidian">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-sandy border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="font-manrope text-sm text-white/50">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated === false) {
    const handleLogin = () => {
      const redirectUrl = window.location.origin + '/admin';
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
      <div className="min-h-screen bg-bone flex items-center justify-center px-6" data-testid="admin-login-page">
        <div className="max-w-sm w-full text-center">
          <Link to="/" data-testid="login-home-btn">
            <Button variant="outline" className="rounded-full font-manrope text-sm px-6 mb-10">
              <Home className="w-4 h-4 mr-2" /> Home
            </Button>
          </Link>

          <div className="mb-8">
            <div className="w-14 h-14 rounded-full bg-sandy/10 flex items-center justify-center mx-auto mb-5">
              <Compass className="w-7 h-7 text-sandy" />
            </div>
            <h1 className="font-cormorant text-3xl font-light text-midnight mb-2" data-testid="login-title">Log in</h1>
            <p className="font-manrope text-sm text-midnight/40">Admin Dashboard</p>
          </div>

          <Button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="w-full rounded-full bg-midnight text-white hover:bg-midnight/90 h-12 font-manrope text-sm tracking-wide"
          >
            <LogIn className="w-4 h-4 mr-2" /> Sign in with Google
          </Button>

          <p className="font-manrope text-[10px] text-midnight/25 mt-6">
            Access restricted to authorized administrators only.
          </p>
        </div>
      </div>
    );
  }

  return children;
};
